import ApiService from '../apiservice'

class UsuarioService extends ApiService {

  constructor() {
    super('/usuarios')
  }

  autenticar(usuario) {
    return this.post('/autenticar',usuario);
  }

  cadastrarUsuario(usuario) {
    return this.post('/',usuario);
  }

  listarUsuario(filtroUsuario) {
    const params = `?empresa=${filtroUsuario.empresa}&nome=${filtroUsuario.consulta}`
    return this.get(params);
  }

  consultarUsuario(codigo) {
    return this.get(`/${codigo}`);
  }

  excluirUsuario(codigo) {
    return this.delete(`/${codigo}`);
  }

  alterarUsuario(usuario) {
    return this.put(`/${usuario.codigo}`, usuario);
  }

  listarUsuariosSemGrupo(grupoConsulta) {
    const params = `?empresa=${grupoConsulta.empresa}&grupo=${grupoConsulta.grupo}`
    return this.get(`/usuariosSemGrupo${params}`);
  }

  listarUsuariosSemGrupoPessoas(grupoConsulta) {
    const params = `/usuariosSemGrupoPessoas?empresa=${grupoConsulta.empresa}&grupo=${grupoConsulta.grupo}`
    return this.get(params);
  }

  listarUsuariosEmpresa(empresa) {
    return this.get(`/empresa/${empresa}`);
  }

  listarUsuariosEmpresaFiltrado(usuario) {
    return this.get(`/empresaFiltrado/${usuario}`);
  }

  alterarSenha(senha, novaSenha, confirmacao, usuario) {
    return this.put(`/alterarSenha?codigo=${usuario.codigo}&senha=${senha}&novaSenha=${novaSenha}&confirmacao=${confirmacao}`, usuario);
  }

  logout(log) {
    return this.post('/log',log);
  }

  listarShorts(empresa) {
    return this.get(`/shorts/${empresa}`);
  }
}

export default UsuarioService